import { Button, Card } from 'antd';
import styled from 'styled-components';

export const ProfileCard = styled(Card)`
  height: unset;
`;

export const Btn = styled(Button)`
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  padding: 0;
  height: unset;
  color: var(--secondary-color);
`;
